import { EMPLOYMENT_TYPE, type EmploymentType } from "./constants";

/** The value the external /available endpoint filters on. */
export type TherapistType = "internal" | "external";

/**
 * Map the employment-type filter to the external `therapist_type` param:
 * KARPIS (internal employee) → "internal", FLAT ("MITRA" partner) → "external".
 */
export function employmentTypeToTherapistType(
	value: EmploymentType,
): TherapistType {
	return value === EMPLOYMENT_TYPE.KARPIS ? "internal" : "external";
}

/** Reverse of {@link employmentTypeToTherapistType}: internal → KARPIS, external → FLAT. */
export function therapistTypeToEmploymentType(
	value: TherapistType,
): EmploymentType {
	return value === "external" ? EMPLOYMENT_TYPE.FLAT : EMPLOYMENT_TYPE.KARPIS;
}

/** UI label for a therapist_type: internal → "KARPIS", external → "MITRA". */
export function therapistTypeLabel(value: TherapistType): string {
	return value === "internal" ? "KARPIS" : "MITRA";
}
